import React, { useEffect } from 'react';
import {useTranslation} from "react-i18next";
import {Link, useLocation} from "react-router-dom";

function Footer() {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const currentLang = i18n.language;

    // Force re-render when language changes
    useEffect(() => {
        // This effect will trigger when i18n.language changes
    }, [i18n.language]);

    // Helper per generare link localizzati
    const localizedPath = (path) => {
        if (!path.startsWith('/')) path = '/' + path;
        const parts = location.pathname.split('/');
        if (['it', 'en', 'es', 'fr', 'de', 'pt'].includes(parts[1])) {
            // mantieni la lingua corrente
            return parts.slice(0, 2).join('/') + path;
        } else {
            return '/' + currentLang + path; // usa la lingua attuale da i18n
        }
    };

return (
    <footer className="border-t border-gray-700 mt-16 py-8" id="contact">
        <div className="text-center">
            <p>{t('general.copyright')}</p>
            <p className="mt-2">{t('footer.experiment')}</p>
            <div className="flex justify-center space-x-6 mt-4">
                <Link to={localizedPath('/privacy')} className="hover:text-white transition duration-300">{t('footer.privacyPolicy')}</Link>
                <Link to={localizedPath('/terms')} className="hover:text-white transition duration-300">{t('footer.termsOfService')}</Link>
                <Link to={localizedPath('/contact')} className="hover:text-white transition duration-300">{t('footer.contactUs')}</Link>
            </div>
        </div>
    </footer>
)
}

export default Footer